// extracted by mini-css-extract-plugin
module.exports = {"startingPrice":"_725b86"};